let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("f2Cco")).then(() => parcelRequire('3Y6Au'));